import { render, staticRenderFns } from "./RevenueSummary.vue?vue&type=template&id=39137279"
import script from "./RevenueSummary.vue?vue&type=script&lang=js"
export * from "./RevenueSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports